// extracted by mini-css-extract-plugin
export default {"body":"app_body__sISRI"};